import t from"react";import{Image as e}from"@netfront/ui-library";const r=({asset:{alt:r,presignedUrl:n}})=>t.createElement(t.Fragment,null,n&&t.createElement(e,{altText:String(r??""),src:n}));export{r as ImageSnippet};
//# sourceMappingURL=ImageSnippet.js.map
